import { render } from "./WebFont.vue?vue&type=template&id=2c0ac804&scoped=true&lang=true"
import script from "./WebFont.vue?vue&type=script&lang=js"
export * from "./WebFont.vue?vue&type=script&lang=js"

import "./WebFont.vue?vue&type=style&index=0&id=2c0ac804&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0ac804"]])

export default __exports__